module.exports = __webpack_public_path__ + "static/media/crickbat.40f77e11.png";